import {motion} from 'framer-motion';
import '../CSS/overlay.css'

const Overlay = ({children, closeModal}) =>{
    const variants = {
        open: { background: "rgba(0,0,0,0.6)"},
        close: {background: "rgba(0,0,0,0)"}
    }

    return(
        <motion.div className="overlay" 
            variants={variants}
            initial="close"
            animate="open"
            exit="close"
            onClick={closeModal}> 
            {children}
        </motion.div>
    )
}

export default Overlay;